import React from 'react';
import {Layout, Typography, Button} from 'antd';
import {useNavigate} from 'react-router-dom';
import Header from "../../../components/molecules/Header/component";
import {useIsMobile} from '../../../utils/helpers';
import Footer from "../../../components/molecules/Footer/component";
import Seo from '../../../components/atoms/Seo/component';

const {Content} = Layout;
const {Title, Paragraph} = Typography;

const ContactPage: React.FC = () => {
    const navigate = useNavigate();
    const isMobile = useIsMobile();

    return (
        <Layout style={{minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "white"}}>
            <Seo
                title="Contact Promotify"
                description="Contact Promotify support for help with accounts, billing, payouts, campaigns, or partnership questions."
                canonicalPath="/contact"
            />
            <Header/>
            <Content style={{flex: 1, maxWidth: 900, margin: '0 auto', padding: '32px 16px 48px'}}>
                <article>
                    <header>
                        <Title level={2}>Contact</Title>

                        <Paragraph>
                            If you need help with your account, billing, payouts, or campaigns,
                            our support team is here to assist you.
                        </Paragraph>

                        <Paragraph>
                            Email: <a href="mailto:info@promotifyai.com">info@promotifyai.com</a>
                        </Paragraph>

                        <Paragraph>
                            We typically respond within 1 business day.
                        </Paragraph>

                        <Paragraph>
                            Registered office:<br/>
                            Promotify AI Ltd<br/>
                            210 Leigh Road<br/>
                            Leigh-on-Sea, England<br/>
                            SS9 1BS
                        </Paragraph>
                    </header>

                    <footer
                        style={{
                            marginTop: 24,
                            display: 'flex',
                            gap: 8,
                            flexDirection: isMobile ? 'column' : 'row',
                            justifyContent: isMobile ? 'stretch' : 'flex-end'
                        }}
                    >
                        <Button
                            type="default"
                            onClick={() => navigate('/pricing')}
                            block={isMobile}
                            style={{width: isMobile ? '100%' : 'auto'}}
                        >
                            View plans
                        </Button>
                    </footer>
                </article>
            </Content>
            <Footer/>
        </Layout>
    );
};

export default ContactPage;
